function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M122.735,55.676L53.951,82.395c-2.797,1.086-4.677,3.736-4.78,6.735c-0.103,2.999,1.592,5.771,4.309,7.045l26.172,12.286 l12.291,26.172c1.239,2.638,3.888,4.312,6.788,4.312c0.086,0,0.172-0.001,0.258-0.004c2.999-0.103,5.647-1.983,6.734-4.78 l26.719-68.778c1.076-2.771,0.414-5.917-1.688-8.019C128.651,55.262,125.503,54.6,122.735,55.676z M98.079,112.413l-6.001-12.778 c-0.744-1.584-2.018-2.858-3.602-3.601l-12.773-5.996l36.59-14.213L98.079,112.413z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.052,0C42.192,0.001,0.001,42.194,0.001,94.055c0,51.862,42.191,94.056,94.052,94.057 c51.864-0.001,94.058-42.194,94.058-94.056C188.111,42.193,145.916,0,94.052,0z M94.052,173.111 c-43.589-0.001-79.052-35.465-79.052-79.057c0-43.59,35.462-79.054,79.052-79.055c43.593,0,79.058,35.464,79.058,79.056 C173.111,137.646,137.645,173.11,94.052,173.111z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgGoToLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.111 188.111",
    style: {
      enableBackground: "new 0 0 188.111 188.111"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToLocation);
export default __webpack_public_path__ + "static/media/go-to-location.a6976a2b.svg";
export { ForwardRef as ReactComponent };